import {
    communityCancelModelUpdate,
    communityApplyModelUpdate
} from "../../../../actions/community-actions"

import buildEditFormActionButtonsWidgetContainer from "../../../common/build-edit-form-action-buttons-widget-container"

export default buildEditFormActionButtonsWidgetContainer(
    communityApplyModelUpdate,
    communityCancelModelUpdate,
    "communities"
)
